module.exports = __webpack_public_path__ + "img/Group252.84612a6b.webp";